import ProjectHeroCrisisConnect from "../../../components/ProjectHero/CrisisConnect/ProjectHeroCrisisConnect";
import ProjectDetailsCrisisConnect from "../../../components/ProjectDetails/CrisisConnect/ProjectDetailsCrisisConnect";


function ProjectPageCrisisConnect() {
    return (
        <>
            <ProjectHeroCrisisConnect />
            <ProjectDetailsCrisisConnect />
        </>
    )
}

export default ProjectPageCrisisConnect;